// Actions
import moment from 'moment';
import numeral from 'numeral';

import {
  LONG_HUMAN_DATE_FORMAT,
  SHORT_HUMAN_DATE_FORMAT,
  SUPER_SHORT_HUMAN_DATE_FORMAT
} from 'constants';

export function currency(number) {
  return numeral(Number(number)).format('$0,0[.]00');
}

export function longDate(date) {
  return moment(date).format(LONG_HUMAN_DATE_FORMAT);
}

export function shortDate(date) {
  return moment(date).format(SHORT_HUMAN_DATE_FORMAT);
}

export function superShortDate(date) {
  if (moment().year() !== moment(date).year()) return shortDate(date);

  return moment(date).format(SUPER_SHORT_HUMAN_DATE_FORMAT);
}
